// Design-media service configs for Post a Project (Atrium Stage 7).
//
// Group-map keyed by the JobPosting boolean column, consumed by services/index.js
// (the writing-group agent spreads WRITING_CONFIGS, DESIGN_MEDIA_CONFIGS, and
// ENHANCE_TEXT_CONFIGS into SERVICE_CONFIGS). See CONFIG-SCHEMA §0.

import { coverDesign } from "./coverDesign"
import { illustration } from "./illustration"
import { narration } from "./narration"

export const DESIGN_MEDIA_CONFIGS = {
  cover_design: coverDesign,
  illustration,
  narration,
}
